import { render, staticRenderFns } from "./storeStatistics.vue?vue&type=template&id=178a2a26&scoped=true"
import script from "./storeStatistics.vue?vue&type=script&lang=js"
export * from "./storeStatistics.vue?vue&type=script&lang=js"
import style0 from "./storeStatistics.vue?vue&type=style&index=0&id=178a2a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a2a26",
  null
  
)

export default component.exports